export const ROUTES = {
  ACTIVITIES: 'activities',
  AUTOFATTURE: 'autofatture',
  CUSTOMERS: 'customers',
  DASHBOARD: 'dashboard',
  ENTRATE: 'entrate',
  FINANCIAL_REPORT: 'financial-report',
  REPORT_RS: 'report-rs',
  FORGOT_PASSWORD: 'forgot-password',
  GESTIFY_CREDENTIALS: 'gestify-credentials',
  INSERIMENTO_VELOCE: '',
  JOBS: 'jobs',
  ORDER_COUNTERS: 'order-counters',
  ORDERS_SCHEDULED: 'orders-scheduled',
  ORDERS: 'orders',
  PREVISIONALE: 'previsionale',
  PRINT_PAGE: 'print-page',
  PURCHASE_INVOICE_ACTIVITIES: 'purchase-invoice-activity',
  PURCHASE_INVOICE: 'purchase-invoice',
  QUICK_INSERT: 'quick-insert',
  REPORT: 'report',
  RESET_PASSWORD: 'reset-password',
  RESOURCE_SKILLS: 'resource-skills',
  RESOURCES: 'resources',
  SALES_INVOICE_ACTIVIES_ORDERS: 'sales-invoice-activies-and-orders',
  SALES_INVOICES: 'sales-invoices',
  SCHEDULED_PAYMENTS: 'scheduled-payments',
  SCHEDULED_VALUES: 'scheduled-values',
  SIGN_IN: 'sign-in',
  SKILLS: 'skills',
  SUPPLIERS: 'suppliers',
  TIMESHEET_SINGLE: 'timesheet_single',
  TIMESHEETS_REPORT_GLOBAL: 'timesheets-report-global',
  TYPE_OF_PAYMENTS: 'type-of-payments',
  UNAUTHORIZED: 'unauthorized',
  USCITE: 'uscite',
  USERS: 'users',
  BROWSE_ICONS: 'browse_icons',
};
